import { useCallback } from "react"
import { useSearchParamOpener } from "@/v2-backoffice-client/utils"
import type { ExtraParams, NavOptions } from "@/v2-backoffice-client/utils"
import type { AppViewSheetKind } from "@/v2-backoffice-client/app/AppRouter"
import { useAppViewSheetBreadcrumb } from "@/v2-backoffice-client/app/AppViewSheetBreadcrumbProvider"

function getParamValue(
  kind: AppViewSheetKind,
  value: string | number | null | undefined,
) {
  let val = kind || ""
  if (value) val += ":" + value
  return val
}

export function useAppViewSheetOpener() {
  const opener = useSearchParamOpener("v")
  const { stack, current } = useAppViewSheetBreadcrumb(opener.activeValue)

  return {
    stack,
    id: current?.id,
    kind: current?.kind,
    getIsActive: useCallback(
      (kind: AppViewSheetKind, value: string | number | null | undefined) => {
        if (!kind || !current) return false
        return current.kind === kind && current.id === String(value)
      },
      [current],
    ),
    open: useCallback(
      (
        kind: AppViewSheetKind,
        value?: string | number,
        extra?: ExtraParams,
        options?: NavOptions,
      ) => {
        opener.open(getParamValue(kind, value), extra, options)
      },
      [opener],
    ),
    close: useCallback(
      (extra?: ExtraParams) => {
        opener.close(extra)
      },
      [opener],
    ),
  }
}
